import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { ComplaintManagementComponent } from './complaint-management.component';
import { ComplaintService } from '@fuse/services/complaint/complaint.service';
import { MatIconModule, MatButtonModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatSnackBarModule, MatSelectModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComplaintListComponent } from './complaint-list/complaint-list.component';
import { ComplaintFormDialogComponent } from './complaint-form/complaint-form.component';

const routes = [
    {
        path: 'complaint',
        component: ComplaintManagementComponent

    }
];

@NgModule({
    declarations: [
        ComplaintManagementComponent,
        ComplaintListComponent,
        ComplaintFormDialogComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatSnackBarModule,
        MatSelectModule,
        MatTooltipModule
    ],
    providers: [
        ComplaintService
    ],
    exports: [
        ComplaintManagementComponent
    ]
    ,
    entryComponents: [
        ComplaintFormDialogComponent
    ]
})

export class ComplaintManagementModule {
}
